import { FAIcon, Theme, SearchDataStructure, AttributeTypes, TagStyle, Tag } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';

type ILocationBO = {
  [key: string]: DynamicObjectInterface;
};

const dataSearchOption: SearchDataStructure[] = [
  {
    name: 'Location Code',
    key: 'locationCode',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Location Name',
    key: 'locationName',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  // {
  //   name: 'Enrollment Type',
  //   key: 'enrollmentType',
  //   type: AttributeTypes.DropdownSingleSelect,
  //   visibility: true,
  //   dataset: [
  //     {
  //       key: 'participant',
  //       value: 'PARTICIPANT',
  //     },
  //     {
  //       key: 'coach',
  //       value: 'COACH',
  //     },
  //     {
  //       key: 'leader',
  //       value: 'LEADER',
  //     },
  //   ],
  // },
];

const getLocationListConfig: GetColumnsType = (styles: Object, translation: Function, cb: DynamicObjectInterface) => [
  {
    key: 'locationCode',
    text: translation('admin.locationMaster.locationCode'),
    sortable: true,
    width: 4,
    render: (object: ILocationBO) => <span>{object.locationCode}</span>,
  },
  {
    key: 'locationName',
    text: translation('admin.locationMaster.locationName'),
    sortable: true,
    width: 14,
    render: (object: ILocationBO) => <span>{object.locationName}</span>,
  },
  // {
  //   key: 'enrollmentType',
  //   text: translation('admin.LocationMaster.enrollmentType'),
  //   sortable: true,
  //   width: 10,
  //   render: (object: ILocationBO) => <span>{object.enrollmentType}</span>,
  // },
  {
    key: 'status',
    text: translation('admin.locationMaster.status'),
    sortable: true,
    width: 5,
    render: (object: ILocationBO) => (
      <span>
        <Tag
          theme={object.status === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  // {
  //   key: 'action',
  //   width: 5,
  //   text: 'Actions',
  //   render: (object: ILocationBO) => (
  //     <>
  //       <FAIcon
  //         iconName={'edit'}
  //         onClick={e => {
  //           cb?.onEdit(object.recId);
  //           e.stopPropagation();
  //         }}
  //         theme={Theme.PURPLE}
  //         title={'Edit'}
  //       />
  //       {' | '}
  //       <FAIcon
  //         iconName={'trash-can'}
  //         onClick={e => {
  //           cb?.onClick(object.recId);
  //           e.stopPropagation();
  //         }}
  //         theme={Theme.PURPLE}
  //         title={'Delete'}
  //       />
  //     </>
  //   ),
  // },
];

export default getLocationListConfig;
export { dataSearchOption };
